import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  UserFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";
import { useHistory } from 'react-router-dom';

import { Header, ProductDetails } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const EditPermissions = withRouter(props => {

  const classes = useStyles();
  const [productobj , setProductobj] = useState({});
  const [userid, setUserid] = useState('');
  const [viewtype, setViewtype] = useState(1);
    const history = useHistory();

  const [masters, setMasters] = useState({
    commodity :[]
  });
  const snackbarCtx = React.useContext(SnackBarContext);
  
  var product_id = props?.location?.pathname?.split('/')?.[2]??null;

  const { sendNetworkRequest } = React.useContext(NetworkContext);


  async function fetchmasters()
  {
    let roles_arr = await sendNetworkRequest('/admin/getroles', {}, {},false)
    
   

    let menu = await sendNetworkRequest('/admin/getmodules', {}, {type : 'menu'},false)
    
    setMasters({
      ...masters,
      roles : roles_arr,
      menu : menu.module
    })
  }
  async function updateproductinfo(productdetails)
  {
    console.log(JSON.stringify(productdetails))
    //alert(JSON.stringify(productdetails))
     let prodinfo = await sendNetworkRequest('/admin/updateaccess', {}, productdetails,false)
     if(prodinfo.statusCode === 200){
      history.push('/manageroleaccess');
     }
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: prodinfo.status,
      msg: prodinfo.message,
      vertical: "top",
    });
    

  }
  async function fetchaccesinfo(prodid)
  {
    let prodinfo = await sendNetworkRequest('/admin/getpermissions', {}, {access_id : prodid},false)
    if(prodinfo && prodinfo.module && prodinfo.module.length > 0)
    {
      let accessobj = prodinfo.module[0]
     setProductobj({
      ...accessobj
     })
     
    }

   
  }
  useEffect(() => {
     var product_id = props.location.pathname.split('/')[2];
    // var viewtype = props.location.pathname.split('/')[3];
    // setViewtype(viewtype)
    // setUserid(user_id)

    fetchmasters()
    if(product_id){
      fetchaccesinfo(product_id);
    }
    
    
  }, []);

  return (
    <Page
      className={classes.root}
      title="Commodity"
    >
      <Header id={product_id}/>
     <ProductDetails usercontent={productobj} masters={masters} viewtype={viewtype} onUpdate={updateproductinfo}/>  
     
    </Page>
  );
});

export default EditPermissions;
